// extracted by mini-css-extract-plugin
export var menuIcon = "_r2-0";
export var menuIconInline = "_r2-1";